import { FileType } from "../enums/file-type";

export const MIME_TYPES = [
    {
      name: FileType.csv,
      extension: "csv",
      mimeType: "text/csv"
    }
  ]